var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLemonWithMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1842 2223",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1594 64l10 20c9 17 7 35 6 52l-8 39c-5 17-8 35-16 51-3 8-5 17-10 25l-9 19-1 3-3 5a411 411 0 01-92 112c-5 4-3 7 2 10a618 618 0 0179 64c22 20 42 41 60 63 8 9 16 17 23 27 19 25 38 52 55 79l5 5c2 5 4 10 8 14 9 13 16 27 24 41l5 9c17 28 30 58 43 89l2 5c2 7 3 14 6 20l2 5 1 3 5 13c17 58 31 116 40 176 11 73 11 145 10 218 0 24-3 48-6 72l-1 11c-5 14-3 28-6 42l-13 59-2 3-2 9c-2 16-8 32-13 48l-1 3-1 6c-2 10-7 20-10 29l-3 4c-7 21-18 41-27 61l-1 2c-1 3-3 5-3 8-8 17-18 33-28 50l-27 42-24 33c-15 20-30 39-47 57l-38 42c-14 12-26 25-39 38l-13 12c-7 10-7 23-11 34l-4 14c-6 15-10 31-15 47-9 31-18 63-30 94a585 585 0 01-49 99c-24 34-53 58-94 67-36 9-69 1-98-22l-10-7a385 385 0 01-65-83l-16-26-2-5-1-2-1-3-1-1-1-3-1-2-2-3-1-2c-1-4-4-3-7-3-7 0-14-1-21 1l-30 3c-30 4-59 2-88-2-13-2-26-2-39-2-10 10-13 25-21 36l-2 3c-6 10-13 19-18 29-4 8-11 13-15 22l-30 34c-15 15-32 28-51 36l-20 6c-41 5-76-7-107-32-8-7-16-14-22-23l-3-4-22-32a909 909 0 01-50-116l-5-18-8-23-3-14-1-2c0-5-2-9-3-13l-1-2-2-5v-3c0-4-2-8-4-12l-3-12-12-42c-2-7-5-13-10-17l-25-25-31-32a1124 1124 0 01-113-145l-22-39-24-48c-12-20-19-41-27-62l-18-58c-7-26-13-51-18-77-6-29-8-57-12-86-2-21-2-42-3-64-1-4-2-8-6-11-32-33-61-68-91-102-25-29-50-57-72-88-14-20-29-39-42-60-13-19-23-39-29-61-6-25-3-50 11-72 3-5 7-9 12-12l2-2 3-1c17-14 37-18 58-21 33-4 66-2 99 1 37 4 74 8 111 15 6 1 8-2 10-7 4-7 7-14 9-22 5-13 11-26 18-38l4-10 16-27c12-23 26-46 41-68l17-27a673 673 0 01109-129c14-14 29-27 45-39 41-33 86-62 129-93l9-7 52-40c17-13 32-28 46-45l24-28 20-25c10-10 18-21 29-30l12-11c14-13 29-24 45-33 19-9 36-20 57-24a212 212 0 01124 6c8 5 15 0 21-5 19-10 37-23 56-33l18-11 41-19c29-10 58-21 88-26a463 463 0 0179-10c16-1 31 1 47 2h5c3 2 7 2 10 2l5 1c3 2 7 1 10 1l27 7c30 9 55 25 72 51",
    fill: "#1f1f27",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M498 620c8-13 18-24 28-36a619 619 0 01133-122l7-4 20-14 36-25a2107 2107 0 00103-79c9-8 18-16 26-26l44-51c13-16 26-31 40-44 20-19 41-35 67-45a121 121 0 01116 19c15 10 29 22 42 36l37 42a509 509 0 0098 98c17 13 35 27 53 39l36 25c28 20 56 40 83 62l5 3c37 29 69 64 98 100 13 16 25 32 36 49l6 9a914 914 0 0190 168l15 42c10 38 21 76 27 115l1 10 1 4 1 5 1 2v7a1015 1015 0 01-111 386 1122 1122 0 01-365 411 1122 1122 0 01-233 117c-37 13-75 25-114 34l-18 3-7-1-4-1-12-3-4-1-4-1-24-8-3-1-27-8c-49-19-96-40-140-69l-19-13-31-24c-23-18-45-38-65-59l-3-3c-20-22-42-43-61-66a815 815 0 01-125-206l-8-15a1005 1005 0 01-32-493c8-47 22-93 35-138l16-43 12-27 19-38c5-13 14-25 21-38l4-6 2-2c9-11 15-24 24-36l27-40",
    fill: "#f8dc00",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M906 1958l21-4 15-4 29-8c16-5 31-11 48-14l9-4 69-27 49-22c2-2 5-2 7-3l14-8 12-6 10-5c6-3 10-8 16-9l5-3c4-4 11-5 15-10 12-5 21-13 31-18l5-2c6-7 14-11 22-16l35-25a217 217 0 0032-26c9-4 16-11 23-18l20-16 8-8c2-4 5-7 8-9 4-2 7-6 10-9l29-29 32-33 28-33 13-17c5-8 10-16 17-22l10-15 20-28 9-14 2-4c7-8 11-17 17-26l11-19c8-16 20-30 26-48 1-4 4-7 6-10l18-41c8-15 13-31 20-46a189 189 0 0013-37c7-15 10-32 16-47l10-36 9-37 5-24 6-33 5-32 3-27 1-13c0-2 0-4 2-5 1-1 2 0 2 1l1 7a1117 1117 0 019 250c-2 29-8 57-12 86-6 35-16 68-24 102l-11 30c-3 10-8 19-12 29a821 821 0 01-104 172l-29 34-19 21-18 19-29 29c-17 17-35 32-54 47l-1 1a549 549 0 01-116 71 857 857 0 01-251 74c-42 3-84 2-125-9-7-3-14-1-20-4l-4-1-7-1-2-1c-5-2-11-2-15-7",
    fill: "#f3be00",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1266 222c-6 3-7 3-10-2-7-11-17-20-25-30l-24-25-21-19c-3-4 0-6 4-8 53-35 110-59 173-70l27-4c5 0 9 1 13-1l7-1h43l6 1 9 1 6 1 8 1 4 1 4 1 4 1 4 1 2 1 5 1 2 1 3 1 2 1 3 1 2 1 2 2h2l3 2 2 1 3 1 3 4 9 9c7 9 8 17 0 27a568 568 0 01-202 162c-13 7-17 6-27-4-5-5-5-9 0-13 15-15 30-31 46-44 3-4 7-6 10-8 12-9 25-17 38-24 12-6 24-12 35-20 3-2 6-5 7-9 5-10 1-18-10-19-12-1-24 2-35 6a658 658 0 00-136 73",
    fill: "#6428b1",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M651 1938c13 10 28 17 43 25l9 5c18 11 39 19 59 28 29 13 60 23 91 33l21 6c13 3 13 3 7 13l-2 3-1 2a463 463 0 01-46 73c-11 11-22 23-37 31-19 10-38 5-56-4-25-15-41-38-55-63-11-20-19-42-28-63-9-27-19-54-26-81l-2-7-1-3c-2-11-2-11 5-10 6 5 12 8 19 12",
    fill: "#f3be00",
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1358 224c-2 5-6 8-10 11l-12 11-21 20-5 5v6l2 1c11 12 12 12 26 5l38-20 31-20a605 605 0 00135-126c4-5 4-10 1-15l-7-10-6-6h3c4 2 6 6 9 9 4 5 6 11 7 18 0 19-3 37-7 54l-10 33-8 21c-6 11-11 23-18 33-8 13-15 25-24 37l-20 23-36 35-1 2c-10 9-10 9-21 1-14-9-28-19-41-30l-26-20a1046 1046 0 01-28-23c-3-3-3-6 0-10l2-3 27-26c5-6 11-10 17-15l3-1",
    fill: "#531fa2",
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1723 1454c-1-4 0-8 1-11l12-42c-1-8 4-15 5-23l3-22 5-29c2-13 6-26 6-40l2-16 1-11 1-25c0-6-1-12 1-17v-8a26416 26416 0 00-1-75v-8l-1-27c1-9 0-17-3-26v-8c0-10-2-19-4-29l-3-23h3c2 3 1 6 2 10a782 782 0 019 75l1 29 1 62-3 70c-2 25-5 51-10 77l-8 45c-3 16-8 32-13 48l-5 21-2 3",
    fill: "#bf9c09",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1533 86h-3l-3-2-3-2h-1l-3-2h-1l-3-2h-1l-3-2h-1l-5-2h-1l-4-2h-2l-5-2h-3l-5-2h-3c-3-2-6 0-9-2h-5c-3-2-6 0-9-2a1432 1432 0 00-51 0h-6c-4 3-9 0-12 2l-18 2-35 6-17 5a500 500 0 00-131 60c-2 2-4 4-4 7-1 0-2 0-3-2l1-3 3-4 36-21 29-14a398 398 0 01116-37l27-3c17-3 34-1 52-2 9 0 18 2 26 3 11 1 21 4 31 7 9 3 17 7 25 12l4 4",
    fill: "#4c2592",
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M373 1482c3 2 4 6 5 9a577 577 0 0040 84 744 744 0 00103 145l29 31c5 5 11 11 14 17-4 0-6-4-9-7l-25-27-31-35-16-21a739 739 0 01-84-132c-10-19-18-39-26-58-2-2-2-4 0-6",
    fill: "#bda10c",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M375 848l-13 43-10 41-5 19c-3 12-6 24-7 36 0 7-2 15-4 22l-3 23-6 45v2l-3 39c-2 29-1 58-1 86l-1 4h-1v-87l3-33c0-15 3-29 4-43l3-18 7-41 1-8 1-10 10-42 4-15c3-18 11-36 15-54 1-5 2-10 5-13 2 1 2 3 1 4",
    fill: "#9e940e",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147 1010c-2 0-3-2-4-3-20-24-39-48-56-74-9-12-16-24-22-38-4-8-6-17-7-26 0-11 6-18 14-20l11-4c9-2 17-3 26-3l9-1c8 0 16-1 25 1h22c4 3 9 0 14 2h5v3l-6 2c-18 1-36-4-54-2-14 1-29 2-43 5-14 4-18 9-16 23 2 15 9 28 16 40 18 28 38 54 59 80 3 3 6 6 7 10v5",
    fill: "#586119",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M928 1966h4c7 3 14 2 20 4 9 4 19 4 28 6 31 6 62 5 93 4l37-5 47-9 37-9 10-3h5l-1 1-47 13-46 10-43 5c-13 0-26 2-39 1-17-1-33-1-50-5-12-2-24-3-35-7-9 1-17-3-26-4-2-1-6-1-8-4h8c2 2 5 1 6 2",
    fill: "#7a501b",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321 1208h1c1 24 2 47 5 70 1 12 2 24 5 35l2 15 5 30 1 4c1 15 6 30 9 44l10 37 3 10 11 29v6c-4-3-5-8-6-12l-8-25-6-20-8-30c-3-11-6-22-7-33l-5-29-3-13-2-19-6-48c-2-17-1-34-1-51",
    fill: "#6f5e19",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1262 2016l20-8c18-6 37-14 55-22 17-7 34-15 50-24 14-7 29-14 42-23l18-12 5-2c2-1 4 1 4 3l-1 2c-2 8-3 15-6 22l-2 4c-4-4-1-9-1-13 1-4 1-8 5-11a809 809 0 01-174 84c-4 1-7 3-11 2l-4-2",
    fill: "#474c1c",
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147 1010l-1-4c6-1 8 4 11 7l82 95 7-70c0-3-1-9 5-7v13l-6 69v2l-2 2c-1 1-2 0-3-1l-3-2-67-76-20-24-1-2-2-2z",
    fill: "#c8b009",
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M878 2050c2-4 5-7 5-11l-5-2-29-8c-9-2-17-6-26-9l-27-9c-21-7-42-17-62-26l-27-12c-2-1-4-2-4-5l9 3a791 791 0 00166 63h1c8 2 11 5 5 12l-3 4h-3",
    fill: "#baa206",
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1448 1942v8a851 851 0 01-36 107c-10 22-21 45-36 65l-3 3-3-1c0-3 1-6 3-8 22-30 36-65 48-99l21-66c1-4 1-8 6-9",
    fill: "#9a7312",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M663 1854l2 1a702 702 0 00156 79h1l11 4-1 3-9-2-65-28c-14-6-26-13-39-20l-45-28c-5-2-10-4-11-9",
    fill: "#63461e",
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1342 174c7-5 15-8 22-11l17-7c7-4 14-6 21-8l24-5c6-1 12-1 18 1 6 3 10 11 7 17-2 6-6 10-11 13l-29 17-5 1c4-4 8-6 13-8l19-12 8-7c2-3 3-7 2-11 0-4-3-8-7-8-8 0-17-1-25 2l-23 6-27 11-19 9h-5",
    fill: "#512480",
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1287 2158c-18-8-30-22-43-36-12-15-23-31-33-48-2-1-2-3 0-4 5 0 6 4 8 7 14 21 28 42 46 59 18 18 38 25 63 16 2-1 5-2 8 0 1 6-5 4-8 6-14 4-28 6-42 0",
    fill: "#b88a0d",
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M657 2028c2 1 2 4 3 6 8 20 16 39 26 58 9 15 19 30 31 42l17 14 5 4h-4l-3-2-10-7c-17-15-29-34-40-53a393 393 0 01-25-62",
    fill: "#614a1c",
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1570 598c-2 0-4-3-6-5l-14-17c-13-15-27-31-42-45l-32-28-4-5 6 2 21 20a499 499 0 0154 55l15 18c2 2 3 3 2 5",
    fill: "#676c17",
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1330 1906l27-14c25-13 49-28 71-44 6-4 11-9 18-12-1 4-4 6-7 8-17 12-33 24-51 34l-19 11c-13 6-25 14-39 19v-2",
    fill: "#67451d",
    fillRule: "nonzero"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1330 1906v2a707 707 0 01-102 41c-6 2-12 6-19 5h-5c4-3 9-3 13-4l58-20 39-18c5-2 10-5 16-6",
    fill: "#835918",
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1680 774l-2-3c-9-22-22-42-34-63l-29-46c-1-2-3-3-3-6 3 1 5 3 6 5l32 52 13 22c6 10 12 20 16 31 1 3 4 5 4 8h-3",
    fill: "#696917",
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1743 982c-2-9-2-19-5-28l-3-15-8-28-2-10a1108 1108 0 00-8-35l3 5c2 12 7 23 9 36l8 30c4 17 9 34 10 51l2 12-1 1-1-1h-1l-1-4-1-4c-1-3 1-7-1-10",
    fill: "#ae9f0c",
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M736 2152h3l20 7c16 4 31 1 44-9 11-7 20-16 27-26 2-1 2-3 5-2l-2 5c-10 10-20 21-33 29s-27 11-42 6c-8-3-15-5-22-10",
    fill: "#5b3e1f",
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1262 2016h5c-1 6-6 5-9 7l-47 14c-15 4-15 4-7 17l2 8-2 3c-6-8-9-16-13-25-1-1 0-3 2-4l8-2 57-17 4-1",
    fill: "#5b441e",
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251 1044l-1-14c-2-2-2-5-1-7l1-11 1-4 1-13 1-5 1-6c1-15 6-30 9-46 0-3 1-6 5-6 2 2 2 4 1 6l-10 47-4 32-3 25-1 2",
    fill: "#b49e0c",
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M178 846h7c6-1 12-2 18 0h1c4 2 8 0 11 2h3c6 3 11 0 17 2 3 3 7 0 10 2h5c5 3 10 0 15 2 3 3 7 0 10 2h3c3 2 8 0 11 4v2l-1 4-1 2c0 3 0 5-2 7l-1-1-3-8c-2-4-5-4-9-5-28-3-56-8-84-10-4 0-8 1-10-5",
    fill: "#67591b",
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M657 2028l-1 3-5-14c-8-22-15-43-21-65l-2-8 1-1 2 1 10 33 14 44 2 7",
    fill: "#5a471d",
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M835 2122l-5 2 2-4a417 417 0 0046-70h3l-5 10c-11 19-22 37-35 54l-6 8",
    fill: "#ba8b0c",
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M498 620c1 2 0 3-1 5-9 11-17 23-25 36l-10 13-11 20-5 4c-1-1-1-3 1-4l17-26 26-40 8-8",
    fill: "#aea60b",
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1342 174h5l-3 2c-25 13-48 28-71 43-2 2-4 3-7 3 1-3 4-4 6-6l40-25 30-17",
    fill: "#442263",
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1328 2158c2-3 7-3 9-6l34-28 2 1-1 2c-10 12-21 22-35 29-3 1-5 3-9 2",
    fill: "#6b491c",
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1680 774h3l11 24 9 23-1 3c-4-4-5-10-7-15-2-8-6-15-10-23l-5-12",
    fill: "#777415",
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M375 848l-1-4 1-5 14-35 1-2c2 1 2 3 1 4l-10 27c-2 5-3 11-6 15",
    fill: "#afa30b",
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M922 1964h-8l-34-9c-3 0-5-2-8-3h9l2 2 13 2 3 2h7c4 3 8 4 12 4l4 2",
    fill: "#cba20b",
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M443 704l-22 38h-3l2-6 22-36 1 1v3",
    fill: "#51541c",
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1287 2158c6 1 13 3 20 3l16-2 5-1c-1 2-3 2-5 3-10 3-20 5-30 1-2-1-5-1-6-4",
    fill: "#6b491c",
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M418 742h3c0 4-2 7-3 9-7 9-10 20-15 29h-3l11-23 7-15",
    fill: "#b2a80a",
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M269 938v-6l-1-1c0-10 2-20 6-29h3l-5 30c0 3-1 5-3 6",
    fill: "#67591b",
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M400 780h3l-12 26-1-4 10-22",
    fill: "#bdb109",
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M632 1926h-2c-2 0-3 1-3 4l2 8h-2l-4-12c-1-2 0-3 1-4h4c2 1 4 2 4 4",
    fill: "#747315",
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M877 1952h-5l-22-6v-2h5c7 3 15 4 22 8",
    fill: "#cca50b",
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M686 444l-2 4-15 10h-3l3-4c6-3 11-8 17-10",
    fill: "#b3b408",
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M651 1938c-8-2-14-6-19-12 7 3 13 7 19 12",
    fill: "#747315",
    fillRule: "nonzero"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M203 846h-18v-2h12c2 0 4 0 6 2m32 4h-12l-5-2h12l5 2",
    fill: "#464f1d",
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M285 875l-4 13-1-1c-2-5-2-10 4-13l1 1m-4 13c-1 5 0 10-4 14h-1c-2-6-2-11 4-14h1",
    fill: "#67591b",
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M850 1944v2c-5 1-9-1-14-3l1-2c5-1 9 1 13 3z",
    fill: "#63461e",
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M179 844h-10c-2 0-3 0-4-2h8c2 0 4 0 6 2m86 10h-10c-2 0-3 0-5-2h10l5 2",
    fill: "#464f1d",
    fillRule: "nonzero"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1751 1014h-3v-14h1c2 4 2 9 2 14",
    fill: "#ae9f0c",
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1211 2070v4c-5-2-5-6-7-9l1-1h3l1 1 1 2 1 2v1",
    fill: "#5b441e",
    fillRule: "nonzero"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M289 860l-7-2-4-2h6c3 0 4 1 5 4m-14-4c-4 0-8 1-10-2 3 0 7-1 10 2m-30-4c-4 0-8 1-10-2 3 0 7-1 10 2m-30-4c-4 0-8 1-11-2 4 0 8-1 11 2",
    fill: "#464f1d",
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M447 694l-1 4c0 1-1 3-3 3l-1-1c1-3 2-5 5-6",
    fill: "#51541c",
    fillRule: "nonzero"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M627 1938h2v6h-1c-2-1-2-4-1-6",
    fill: "#5a471d",
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M836 1943l-4-2 1-1c2-1 3-1 4 2l-1 1",
    fill: "#63461e",
    fillRule: "nonzero"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M732 2150l3 2-3-2",
    fill: "#5b3e1f",
    fillRule: "nonzero"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M289 862v-2 2m-2 6l1-2-1 2",
    fill: "#464f1d",
    fillRule: "nonzero"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M147 1010l2 2c-2 0-2-1-2-2m2 2l1 2-1-2",
    fill: "#586119",
    fillRule: "nonzero"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1277 985c0-9 1-18 4-27 1-4 1-4-2-6l-21-14-7-6c-5-6-5-13-1-19 5-6 12-8 19-5l7 4 18 12c7 4 6 5 12 0 10-9 22-14 36-17a79 79 0 0131 154 79 79 0 01-95-61c-1-5-2-10-1-15m-470-1c0 43-34 75-71 79a79 79 0 01-82-103c2-7 0-7-4-10l-19-13-8-7c-4-5-4-13 1-18 4-5 11-7 17-5l9 5 20 14c3 2 4 1 6 0a79 79 0 01130 58",
    fill: "#1f1f27",
    fillRule: "nonzero"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1368 1122h27c10 0 18 4 25 11 8 6 11 15 14 25v2c-2 15-7 27-20 34-8 4-16 6-24 6h-47c-14 0-26-6-35-17l-4-10c-9-28 12-51 36-51h28zm-649 0h27c17 2 31 12 36 29 5 19-7 37-19 43-8 4-16 6-24 6h-41c-10-1-21-2-30-9-6-4-10-10-13-17-3-8-3-16-1-24 4-12 12-21 23-25 5-2 11-3 17-3h25z",
    fill: "#ff7261",
    fillRule: "nonzero"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1113 1752c-10 6-22 7-33 8h-33c-20-1-39-6-55-18-9-7-15-15-21-24-8-15-13-31-17-48l-8-37-10-55-5-32c-1-12-5-24-5-37v-5c-2-8-4-16-4-24l-2-16c-1-8-4-14-11-19-4-2-7-7-9-13h4c15 11 22 27 24 46 8 69 18 138 36 206 6 22 15 43 36 56 14 9 29 13 45 13 21 1 42 1 64-3l4 2",
    fill: "#a99a0d",
    fillRule: "nonzero"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M951 1046h1c5-2 10 1 15-2h11c8-2 17 1 25-2 11-1 23 1 34-1l18 1c20-1 39 2 58 2 15 1 30 4 44 7 11 2 21 7 29 14l10 9c12 14 17 30 13 49-2 12-5 23-12 33-2-1-2-3-2-4l7-22c10-41-19-69-50-74-23-4-47-7-71-7l-31-2c-30 0-60 2-90 4-3 0-6 0-9-2v-3",
    fill: "#9e7c13",
    fillRule: "nonzero"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1179 1204c11 8 19 19 26 31 11 15 18 32 23 51 5 21 7 42 3 64-2 9-3 18-6 26-2 1-2 0-3-1-3-4-1-7 0-11 12-56-1-105-39-148-3-4-7-6-7-12h3",
    fill: "#483d21",
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1306 1376l39-16 90-33 14-5c6-2 13-2 20-2 10 0 17 4 23 11l1 3-1 3-2-1c-14-14-29-12-46-6l-93 34-32 12c-3 2-7 3-11 2l-2-2",
    fill: "#70521c",
    fillRule: "nonzero"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M936 1206h-2c-18-12-35-27-46-45a92 92 0 01-16-51c1-12 4-22 11-31l5-7c2-2 4-6 8-6l1 1v1l-1 2-1 1-1 2-1 1-2 2v1l-2 2c-20 29-10 57 6 83 9 13 20 24 34 33l8 8-1 3",
    fill: "#c1a70a",
    fillRule: "nonzero"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1492 1337l1-3c8 13 6 29-7 38-5 4-11 7-16 9l-80 29c-2 1-5 3-7 2l-1-2 2-2 4-3 70-25 16-7c13-6 18-15 17-30 0-2-1-4 1-6",
    fill: "#636e16",
    fillRule: "nonzero"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M903 1432h-3l-1-4c-3-11-2-23-1-34l5-11c2-3 2-7 1-10-5-14-7-28-7-42 0-15 0-29 5-43 3 1 3 4 3 6-3 26-3 51 4 76 1 5 1 9-1 13-5 14-5 27-4 42 0 2 1 5-1 7",
    fill: "#605b1a",
    fillRule: "nonzero"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1380 1414l-5 4c-27 9-53 19-79 30l-31 12-5 1c1-7 6-6 10-8l48-19 2-1c3-1 5-1 7-3l3-1h1l2-1a77 77 0 0014-5l5-2 3-1 15-6c4-1 7-3 10 0",
    fill: "#b1b009",
    fillRule: "nonzero"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1143 1550c3 6 8 10 13 14 17 13 35 24 55 33l12 5-1 3c-2 1-5 0-7-1-26-11-50-24-70-43-3-3-7-6-5-11h3",
    fill: "#5b4120",
    fillRule: "nonzero"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1357 1692c-1 4-4 7-7 9-9 7-20 9-32 6l-39-14-3-3 2-1c12-1 21 6 31 9 12 3 24 6 36 0l2-2 1-1 2-1 1-1 3-1 1-1 1 1h1",
    fill: "#a0a30b",
    fillRule: "nonzero"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1143 1550h-3c-6-5-4-11-2-17 4-9 12-16 20-22 9-9 20-16 32-20l4 1c-2 3-6 5-10 7a116 116 0 00-40 34c-3 5-3 11-1 17",
    fill: "#aaac09",
    fillRule: "nonzero"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M903 1295l-1-7c1-8 4-16 7-23 5-14 12-27 22-39l2 1c1 3-1 5-2 7-11 17-19 35-24 55 0 2-1 5-4 6",
    fill: "#65501d",
    fillRule: "nonzero"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1279 1690h-3c-5 0-10-2-15-4l-39-15-4-3 4-2c19 5 36 13 54 19 2 1 3 3 3 5",
    fill: "#a0a30b",
    fillRule: "nonzero"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1223 1604v-2c6 0 12 4 18 7l42 16c2 0 4 1 5 3-4 3-7 1-11 0-17-7-34-12-50-20-2-1-5 0-4-4",
    fill: "#c0990d",
    fillRule: "nonzero"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1179 1204h-3c-7 0-11-5-13-11-1-6 3-9 7-13 8-6 14-14 20-22 1-2 2-6 6-6l1 4c-6 10-12 18-20 26l-7 6c-3 3-3 4 0 7s7 5 9 9",
    fill: "#666c17",
    fillRule: "nonzero"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1306 1376h3c0 2-1 4-3 4-18 8-36 17-56 22l-4-2 4-3 54-21h2",
    fill: "#6f511c",
    fillRule: "nonzero"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1175 1658c0 7-3 14-5 20-2 11-6 22-11 32-2-1-2-2-2-4 4-16 7-33 15-49l3 1",
    fill: "#b1a40b",
    fillRule: "nonzero"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1175 1658h-3c-2-9 0-14 8-12 15 5 29 12 42 20l1 2h-5c-13-4-25-10-38-16-5-3-4 2-5 4v2",
    fill: "#9c9f0c",
    fillRule: "nonzero"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1246 1400h5c-4 8-12 9-19 10-4 1-7-2-8-5-1-8-5-15-5-22l2-6 1-1h3c-1 5 0 9 1 13l4 13c0 3 2 3 4 2l12-4",
    fill: "#6e511c",
    fillRule: "nonzero"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M897 1068l-1-2c7-6 16-10 25-14 2-2 5 0 8-2 7-2 14-4 21-2h9c-1 5-4 4-7 5-17 1-34 5-49 15-2 1-4 2-6 0",
    fill: "#684c1d",
    fillRule: "nonzero"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1113 1752h-5c0-3 2-4 4-4 14-6 25-16 35-27 1-2 3-4 6-3v3c-8 12-18 21-31 28l-9 3",
    fill: "#96960e",
    fillRule: "nonzero"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1323 1642c8 1 16 5 23 9 8 6 13 13 15 23 1 2 2 5-2 6-3-1-4-3-4-6-3-12-11-20-23-24-4-1-7-2-10-5l1-3",
    fill: "#7e5c1a",
    fillRule: "nonzero"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1194 1492h-4c0-4 2-5 5-7l36-17c2-2 5-2 7-1-2 8-10 7-16 11l-24 12-4 2",
    fill: "#535e19",
    fillRule: "nonzero"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1323 1642l-1 2c-1 1-2 2-3 1-14-4-27-9-41-15-1-1-2-2-1-4l6 1 5 1 30 12 5 2",
    fill: "#5f441f",
    fillRule: "nonzero"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1222 1478c2-3 6-3 8-5 3-2 7-2 9-5 6-5 12-11 21-8h5l-14 7-19 8c-3 2-6 4-10 3",
    fill: "#b3b208",
    fillRule: "nonzero"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M933 1226h-2l9-11c2-4 2-4-2-8l-2-1 1-2c7 0 11 3 9 9-3 6-5 12-13 13",
    fill: "#5e5b1a",
    fillRule: "nonzero"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M898 1394l1 34-2-1c-1-7-3-14-1-22v-7l2-4",
    fill: "#a99a0d",
    fillRule: "nonzero"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1380 1414c-5 0-9 3-14 4-4 2-8 4-13 4 0-7 7-6 11-8l10-4 6-1 2 1 1 2-3 2",
    fill: "#545e19",
    fillRule: "nonzero"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M837 1942l-4-2-4-2-7-4 5 1 20 6 3 3c-4 1-8-3-13-2",
    fill: "#cca50b",
    fillRule: "nonzero"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1003 1042c-2 2-4 2-6 2h-19c2-2 4-2 6-2h19m-53 6l-21 2c3-3 7-3 11-4h11l-1 2",
    fill: "#c29a0d",
    fillRule: "nonzero"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1153 1721l-1-3c-1-6 0-10 6-12l1 4c-1 4-3 8-6 11",
    fill: "#aba30b",
    fillRule: "nonzero"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1358 1680c3-1 2-4 3-6 1 1 2 3 1 5-1 4-1 7-3 9h-1c-2-3-2-5-1-7l1-1",
    fill: "#a0a30b",
    fillRule: "nonzero"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M967 1044c-2 2-3 2-5 2a3429 3429 0 01-5-2h10",
    fill: "#c29a0d",
    fillRule: "nonzero"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1175 1656v-2c0-4 1-4 5-2-3 0-4 3-5 4",
    fill: "#b1a40b",
    fillRule: "nonzero"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1743 982c2 3 1 7 1 10-3-3-1-7-1-10",
    fill: "#f3be00",
    fillRule: "nonzero"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M443 701l3-3c1 3-1 5-3 6v-3",
    fill: "#aea60b",
    fillRule: "nonzero"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M929 1050c-3 3-6 2-8 2 2-3 5-2 8-2",
    fill: "#c29a0d",
    fillRule: "nonzero"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1748 1000v8h-1v-8h1",
    fill: "#bf9c09",
    fillRule: "nonzero"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1194 1492c1-2 3-2 4-2 0 2-2 2-4 2",
    fill: "#aaac09",
    fillRule: "nonzero"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M899 1428c1 1 2 2 1 4-1-1-2-2-1-4",
    fill: "#a99a0d",
    fillRule: "nonzero"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1359 1688l-2 4h-1v-3l1-1h2z",
    fill: "#a0a30b",
    fillRule: "nonzero"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1745 996l1 4c-1-1-2-2-1-4",
    fill: "#f3be00",
    fillRule: "nonzero"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M883 1954l-2-2 2 2",
    fill: "#cca50b",
    fillRule: "nonzero"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M899 1958l-3-2 3 2",
    fill: "#f3be00",
    fillRule: "nonzero"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M952 1970c-6 0-14 1-20-4 7 0 13 3 19 3l1 1m-24-4c-2 0-4 0-6-2 3 0 5 0 6 2",
    fill: "#cba20b",
    fillRule: "nonzero"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1409 64l4-2h37l5 2h-46m-18 2l4-2a2906 2906 0 00-4 2m83 0c3 0 6-1 9 2-3 0-6 1-9-2m-14-2c3 0 6-1 9 2-3 0-6 1-9-2m46 10l5 2c-2 0-4 0-5-2m-5-2l3 2c-1 0-3 0-3-2m-7-2l5 2c-2 0-4 0-5-2m-8-2l5 2c-2 0-4 0-5-2m38 14l3 2-3-2m-4-2l3 2-3-2m-4-2l3 2-3-2m-4-2l3 2-3-2",
    fill: "#531fa2",
    fillRule: "nonzero"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M629 1944a710 710 0 012 0h-2z",
    fill: "#747315",
    fillRule: "nonzero"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M878 2050l-1 2 1-2",
    fill: "#baa206",
    fillRule: "nonzero"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M178 846l4 2 40 4 39 5 21 3c3 1 3 2 3 6-7 22-14 44-16 66-3 2-4 5-5 9l-6 32-2 13-1 4-1 4c-2 4 1 10-1 14l-1 4c-2 3 1 7-1 10l-1 8-1 2a2410 2410 0 00-6 58l-1 10v13c-4-2-7-5-8-8l-10-10-22-26-5-5-22-25-14-17-8-10c-2-2-4-5-7-6a853 853 0 01-76-106c-4-9-7-18-8-28-1-11 2-17 12-20a262 262 0 0181-6h23",
    fill: "#f8dc00",
    fillRule: "nonzero"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1371 2124c-10 12-21 22-34 28l-7 2c-24 9-45 4-64-13-16-15-29-32-41-50l-11-18-3-3-1-2-2-2-5-10-8-13c-1-2 0-4 3-5l26-8 40-12 3-2 7-2 60-23c18-8 36-16 54-26l57-32 3-3 3 1v2l-3 9c-2 2-2 5-3 8-9 33-20 64-32 96-8 20-17 39-28 58l-8 10-6 10",
    fill: "#f3be00",
    fillRule: "nonzero"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1203 2056c4 2 5 6 5 10l-3-2c0-3-3-5-2-8",
    fill: "#bf8f0b",
    fillRule: "nonzero"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M253 1008v-9l1-5v10l-1 4m-2 14c0-3-2-7 1-10 0 3 2 7-1 10m4-32c-1-2 0-3 1-4l-1 4",
    fill: "#c8b009",
    fillRule: "nonzero"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M269 932c-2-8 0-15 2-22l11-40 3-4-1 8-4 14-4 14c-3 8-4 16-5 25l-2 5",
    fill: "#b49e0c",
    fillRule: "nonzero"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1208 2066l3 2h-2l-1-2",
    fill: "#bf8f0b",
    fillRule: "nonzero"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1209 2068h2v2c-2 0-2-1-2-2",
    fill: "#b88a0d",
    fillRule: "nonzero"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1158 1706c-3 3-4 8-6 12l-11 13c-8 9-17 14-28 18-1 1-4 1-5 3-16 5-32 5-48 4h-5c-15 1-29-2-42-7-13-4-24-12-33-23-7-10-12-20-15-31-6-15-8-29-12-44l-10-49-8-53-6-36-5-39-2-17c-1-4-2-8-6-10-6-3-10-9-13-15-3-9-2-18-3-27 0-6 1-12 4-18s3-12 2-18c-6-20-6-40-5-60l2-14 1-3c3-16 8-31 16-45l11-17 2-4c4-3 7-8 10-12 3-3 2-6-2-8l-4-2c-9-6-18-12-25-19-13-12-23-25-29-40-6-14-9-28-7-43 2-7 4-13 8-18l5-8 1-2 2-2 2-2 3-2 3-1c10-8 22-12 35-15l18-2c2 0 4 0 6-2 17-3 35-2 53-3 20-1 39-2 59 1h7c17 0 33 2 50 4l23 2c23 4 40 16 50 36 7 12 7 25 5 38-2 9-5 18-10 26-4 7-8 14-14 20l-10 10-6 6c-2 2-2 5 0 7l10 9 6 7a159 159 0 0144 81c2 7 2 14 3 22v1c2 8 0 17-1 26s-1 18-4 26l-2 9-1 4c-1 3 0 5 1 8l5 16c0 3 2 5 6 4l3-1 15-7c7-1 14-5 21-8l33-13 4-3 9-2 51-19 57-21 31-10c10-4 19-1 28 5l7 8 1 4c4 10-1 23-11 31-6 4-13 7-20 9l-39 14-36 13-5 2h-1l-5 2-21 8-2 2c-2 2-5 0-6 2l-13 5-3 1-3 1-7 3-50 20c-4 3-8 3-11 6-3 0-5 1-8 3l-13 5c-3 0-5 0-7 2l-37 18-5 4-23 15c-8 5-15 12-21 19l-4 5c-4 6-5 13-2 19 0 3 2 5 4 7 9 10 21 18 32 25a324 324 0 0047 22l40 16 14 6 2 2c15 5 29 12 43 16l17 7c7 3 12 8 16 15l1 5 2 9c-2 2 1 6-2 8-1 1 0 3-2 4l-1 2h-1l-1 2-2 2c-9 7-20 8-30 5l-31-11-9-2c-4-3-10-4-15-6l-32-13-9-3c-2-2-4-2-7-3l-31-15-5-2c-4-1-7 0-8 5v5l-3 12-11 36",
    fill: "#1f1f27",
    fillRule: "nonzero"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M897 1068c-1 1-1 2-3 2 1-1 1-2 3-2m-3 2c0 1 0 2-2 2l2-2m-2 2l-2 2 2-2m-2 2l-1 2 1-2",
    fill: "#684c1d",
    fillRule: "nonzero"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1382 1410l5-2c-1 2-3 2-5 2",
    fill: "#444e1d",
    fillRule: "nonzero"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1271 1454l5-4 38-15 7-1c-3 4-8 4-12 6l-33 13-5 1",
    fill: "#4d571b",
    fillRule: "nonzero"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1333 1428c4-2 8-4 14-4-4 4-10 5-14 6l-1-1 1-1",
    fill: "#545e19",
    fillRule: "nonzero"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1321 1434c1-3 4-3 7-4l1 1-1 1c-2 1-4 3-7 2",
    fill: "#4d571b",
    fillRule: "nonzero"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1347 1424c1-2 3-2 6-2-2 2-4 2-6 2m-19 8v-2h3c-1 1-1 2-3 2",
    fill: "#545e19",
    fillRule: "nonzero"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1333 1428v2h-2l2-2",
    fill: "#4d571b",
    fillRule: "nonzero"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1354 1692l2-4v4h-2zm-5 6c0-1 0-2 2-2l-2 2m2-2l1-2-1 2m2-2l1-2-1 2",
    fill: "#7e5c1a",
    fillRule: "nonzero"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1221 1380c-1-2 0-3 1-4l-1 4",
    fill: "#483d21",
    fillRule: "nonzero"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1376 1412l5-2c-1 2-3 2-5 2",
    fill: "#444e1d",
    fillRule: "nonzero"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1356 1688c1-3 0-6 2-8v8h-2z",
    fill: "#7e5c1a",
    fillRule: "nonzero"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M975 1242c6-4 11-11 18-15 14-10 30-17 47-21 14-3 28-2 41-2 10 1 19 4 27 7 11 4 21 10 31 17 17 10 15 27 14 43-4 30-16 56-34 79-9 11-22 19-33 28-17 3-34 1-51 0-26-2-52-4-78-8-6-1-9-4-11-10-10-39-3-74 20-107l9-11",
    fill: "#585858",
    fillRule: "nonzero"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1042 1068c16 3 33 1 49 3l27 1c12 2 23 3 34 7 10 3 18 8 25 17 4 6 7 13 5 21-1 5-2 11-5 15-2 4-3 5-7 4l-26-4a697 697 0 00-63-7l-9-1-24-1h-11l-19 1c-14 0-28 2-42 4l-26 2-32 5c-10 2-11 2-14-8-2-6-4-12-3-19 3-12 10-20 21-25 8-5 17-7 26-8 10-2 21-2 31-3 16-2 32-2 48-2l15-2",
    fill: "#c92323",
    fillRule: "nonzero"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1086 1376c5-6 9-10 16-14 6-3 10-8 14-13a148 148 0 0034-104c0-3-1-5-3-7l-8-10c2 0 4 1 5 3l15 15c12 16 22 34 26 54 5 21 3 41-2 61-2 5-4 7-9 8a1029 1029 0 01-88 7",
    fill: "#404040",
    fillRule: "nonzero"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M943 1396l21 3 15 1 20 3 26 1 29 2c12 1 24 1 36-1l10-1c12 0 23 1 35-2 15 1 29-4 43-4l10-2c7 0 10 3 11 9v6c-1 5-3 9-8 12l-13 5-41 7c-11 1-22 0-33 3h-23c-6 0-13 0-19 2-6 1-13 0-19-1l-9-1a660 660 0 01-81-8l-10-2c-5-1-10-5-13-10-3-3-4-7-3-11 0-8 3-11 11-11h5",
    fill: "#717171",
    fillRule: "nonzero"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M988 1178l-17 10c-3 3-6 3-10 1l-19-13-9-8c-2-1-5-2-4-5 0-3 4-3 7-4l44-5a633 633 0 01171 5c5 1 5 3 3 7-7 9-12 11-23 7-33-13-67-16-101-10-15 3-28 9-42 15",
    fill: "#fc7160",
    fillRule: "nonzero"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1086 1376l9-1 13-1a184 184 0 0043-4c7 1 15-2 22-2 4 0 7-2 8-7 2-3 1-7 3-11a114 114 0 00-7-72c-4-8-8-16-14-23-2-3-5-5-4-9 6 4 9 10 12 16a122 122 0 0118 55v13c0 11-2 21-5 31-1 5-4 8-9 9l-32 4c-10 2-19 2-28 2-10 4-21 0-31 4h-43c-6 0-13 1-19-2h-2c-11 1-21-1-31-2l-32-4c-9-2-11-4-13-13v-4c-4-8-4-15-4-23v-7c-1-28 10-52 26-75 2-3 5-6 9-8-1 2-1 4-3 5-11 13-19 28-24 44a110 110 0 001 72c0 3 2 5 5 5 11 1 21 5 32 4 11 4 22 1 33 4h5l27 2c12 1 24 1 35-2",
    fill: "#322e33",
    fillRule: "nonzero"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M988 1178l6-4a164 164 0 0176-16c13 1 26 3 38 6 9 3 18 5 26 9 5 2 9 2 13-2l3-3c1-2 4-3 4-6-1-3-5-1-7-2l-16-2c-14-2-28-4-42-4l-13-2v-1l1-1 24 1 25 3 29 5c3 0 4 3 2 6-4 4-8 9-13 12h-8c-6-3-12-6-19-7-8-2-15-5-24-6-13-2-25-2-38-2-11 0-21 2-32 5-10 2-19 6-29 10l-6 1",
    fill: "#7b3637",
    fillRule: "nonzero"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M952 1472l-1-3c-1-6 0-8 6-7l31 5c17 2 33 5 50 5 11 1 23 3 35 2l32-3h3c2 0 3 0 4 2l-1 3-7 7-4 5c-1 2-2 6-6 3-1-5 3-7 6-13-23 4-46 0-68 1l-34-5-7-1-5-1-9-1-6-1-5-1-5-1c-5-2-6 2-9 4",
    fill: "#828f91",
    fillRule: "nonzero"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M952 1472l1-2c0-6 1-7 8-4-3 5-2 10-1 16l25 123c1 4 3 9 0 14l-2 1-9-44-10-43-11-52-1-9",
    fill: "#979496",
    fillRule: "nonzero"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1077 1150l-1 2h-47c-13 1-27 1-40 3-14 1-28 2-41 5-6 1-12 0-18 3 0 2 2 2 3 3 3 3 7 6 9 10l-5-2-9-8c-2-2-1-6 2-7h1l17-3 29-3 2-1 41-2c11 0 21-3 32-1l25 1",
    fill: "#a8594f",
    fillRule: "nonzero"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1095 1492l5-4c1 3-1 4-2 6-10 13-14 29-17 45v11c3 12 7 25 15 35l1 3-3 1c-9-5-12-14-15-22-7-25-4-49 11-71l5-4",
    fill: "#3d3c42",
    fillRule: "nonzero"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1107 1710c-4 5-10 5-15 6l-30 2-23-2-14-2-7-4 1-3c8 0 15 4 22 3 22 4 43 0 64-2 2 0 2 1 2 2",
    fill: "#9a8a8d",
    fillRule: "nonzero"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1018 1708v2c-5-1-8-5-11-9-5-6-7-13-10-20-7-18-10-37-14-55v-6h2l1 1c4 11 4 22 8 32 5 20 12 39 24 55",
    fill: "#5b575c",
    fillRule: "nonzero"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1115 1608l21 16c4 2 5 5 5 9v3c-3 10-4 21-8 30-2-1-3-3-3-5 0-7 2-15 4-21 2-7 0-11-5-15l-11-8c-3-3-6-4-6-9h3",
    fill: "#716d71",
    fillRule: "nonzero"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1132 1660l1 6c-2 12-7 22-13 32-3 6-7 11-13 12v-3l1-3c11-9 14-22 19-35 1-3 0-8 5-9",
    fill: "#7b7578",
    fillRule: "nonzero"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1115 1608h-2c-10-2-17-10-19-20h3l18 20",
    fill: "#4a555a",
    fillRule: "nonzero"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1055 1265c0 8-3 15-9 21-8 7-14 15-21 24l-14 14c-10 9-29 5-36-8-7-12-6-24 1-36l11-15c7-8 13-16 22-22 14-10 28-8 39 2 4 4 7 11 7 20",
    fill: "#7e7e7e",
    fillRule: "nonzero"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1045 1436c-5 0-11 1-17-1l-8-1-16-1-6-1c-10 1-21-1-31-3l-17-3-10-3c-6-3-9-7-10-13-1-4 0-7 2-10 1-1 3-2 5-1 5 2 10 1 14 1 6 1 11 1 16 3l11 1c5 0 10 0 15 2h6c4 0 9 0 13 2h35l21 2 2 3-5 20c-1 2-3 3-5 3h-15",
    fill: "#8a8a8a",
    fillRule: "nonzero"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1018 1708c-7-5-12-12-15-21-5-10-8-22-11-33l-7-34-2-15-8-38-10-49-10-46c-1-2-1-4 1-5l5-1h5l4 2h6c3 2 7 0 10 2h4c2 2 5 0 6 2l37 4c6 2 13 1 20 1 8 0 10 3 10 10l1 7-1 134c0 22-2 44-10 65-3 7-5 15-13 19h-8c-3 0-7 0-10-3l-4-1",
    fill: "silver",
    fillRule: "nonzero"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1040 1712l5-8c6-11 9-24 12-36l2-20c3-21 1-41 1-62l1-96c0-13 0-12-13-12h-11c-2 0-3 0-4-2h21c11 2 22 2 33 0 5-1 11 1 17-1l1 1v1l-7 9c-2 1-4 3-3 6-4 8-9 14-12 22-10 27-6 52 11 74 4 9 12 14 19 20 2 6 8 7 12 11l10 7c3 2 4 5 3 9l-6 25-5 17-6 14c-3 6-7 12-12 15l-2 2c-6 3-11 5-17 4l-8 1c-13 2-26 2-39-1h-3",
    fill: "#acacac",
    fillRule: "nonzero"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M986 1470c-3 0-7 1-10-2 4 1 7-1 10 2m10 2c-2 0-4 0-6-2 3 0 5 0 6 2m-26-4c-1 0-3 0-4-2 2 0 3 0 4 2m15 152a436 436 0 018 27l-1 7c-3-5-3-10-4-16-2-6-4-12-3-18",
    fill: "#979496",
    fillRule: "nonzero"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1107 1708l2-2-2 2",
    fill: "#9a8a8d",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonWithMic);
export default __webpack_public_path__ + "static/media/lemon-with-mic.7ad97e84.svg";
export { ForwardRef as ReactComponent };